import React, { forwardRef } from 'react';

import clsx from 'classnames';

import { InputWrapper } from './InputWrapper';

export const InputText = forwardRef(
  (
    {
      className,
      error,
      helpText,
      label,
      optional,
      placeholder,
      variant,
      wrapperClassName,
      name = '',
      readOnly,
      value,
      touched,
      ...props
    },
    ref
  ) => {
    const inputClass = clsx(
      {
        'cdl-input-text': true,
        'cdl-input-text--error': error && touched,
        'cdl-input-text--small': variant === 'small',
        'cdl-input-text--responsive': variant === 'responsive',
      },
      className
    );

    return (
      <InputWrapper
        className={wrapperClassName}
        helpText={helpText}
        htmlFor={name}
        label={label}
        optional={optional}
        touched={touched}
      >
        <input
          ref={ref}
          className={inputClass}
          id={name}
          name={name}
          placeholder={placeholder}
          readOnly={readOnly}
          type="text"
          value={value}
          {...props}
        />
      </InputWrapper>
    );
  }
);
